export default __webpack_public_path__ + "media/examples/animated-33f141c1.jpg";